import React from 'react'
import { makeStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import Chip from '@material-ui/core/Chip';
import useStyles from './style';

const TopHeaderViewer = (props) => {
  const { data, formData, setActiveTabMain, activeTabMain, blockState } = props;
  const { chartData, chartUniqueId } = data || {};
  const classes = useStyles();

  const chatRedirect = (url) => {
    if (url) {
      props.history.push({
        pathname: `/${props?.match?.params?.appid}/page/${url}`
      });
    } else {
      props.history.push({
        pathname: `/${props?.match?.params?.appid}/page/${chartData.listPages}`
      });
    }
  };

  return (
    <React.Fragment>
      <div style={{ display: 'flex', flexDirection: 'column', gap: '20px' }}>

        {chartData?.topBar?.enable && (
          <div className={classes.container}>
            <div className={classes.headerRow}>
              <div className={classes.leftSection}>
                {
                  chartData?.topBar?.backButton?.enable && (
                    <div className={classes.backButton} onClick={() => { chatRedirect(chartData?.topBar?.backButton?.url) }}>
                      <img src={'/media/svg/previousIconObligations.svg'} alt="back" />
                    </div>
                  )
                }
                <Typography className={classes.title}>
                  {chartData?.topBar?.label || 'Opportunity Tracker'}
                </Typography>
              </div>

              <div>
                <Chip
                  label={blockState["status"]}
                  variant="outlined"
                  classes={{ outlined: classes.customChip }}
                />
              </div>
            </div>
          </div>
        )}

        {chartData?.tabs?.enable && chartData?.tabs?.labels && (
          <div className={classes.tabsRow}>
            {Object.entries(chartData.tabs.labels).map(([tabKey, tabLabel]) => {
              const isActive = activeTabMain === tabKey;
              return (
                <div
                  key={tabKey}
                  className={classes.tab}
                  style={{
                    borderBottom: isActive ? '1px solid rgba(63, 81, 181, 1)' : '1px solid transparent',
                    marginBottom: isActive ? '-1px' : '0px',
                  }}
                  onClick={() => setActiveTabMain(tabKey)}
                >
                  <Typography
                    className={classes.tabText}
                    style={{
                      color: isActive ? 'rgba(63, 81, 181, 1)' : 'rgba(120, 121, 142, 1)',
                    }}
                  >
                    {tabLabel}
                  </Typography>
                </div>
              );
            })}
          </div>
        )}
      </div>
    </React.Fragment>
  );
};

export default TopHeaderViewer;
